import React, { useState } from "react";
import "./filter.css";
import { ReactComponent as Settings } from "../../../components/assets/filterSettings.svg";

const Filters = ({ onApplyFilters, onResetFilters }) => {
  const [isOpen, setIsOpen] = useState(false); // State to toggle filter menu
  const [filters, setFilters] = useState({
    type: "Tous",
    etage: "",
    localisation: "",
    dispositif: "",
    prix: 350000,
    prixM2: "",
    loyer: "",
    surface: "",
    honoraires: "",
  });

  const handleChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleApply = () => {
    onApplyFilters(filters);
    setIsOpen(false); // Close menu on apply
  };

  const handleReset = () => {
    setFilters({
      type: "Tous",
      etage: "",
      localisation: "",
      dispositif: "",
      prix: 350000,
      prixM2: "",
      loyer: "",
      surface: "",
      honoraires: "",
    });
    onResetFilters();
  };

  return (
    <div className="filters-wrapper position-relative">
      <div className="filters-header m-0">
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="toggle-button  "
        >
          {isOpen ? <Settings /> : <Settings />}
        </button>
      </div>

      {isOpen && (
        <div className="filters-container">
          <div className="filter-group">
            <label>Types</label>
            <div className="filter-options">
              <input
                type="radio"
                id="type-tous"
                name="type"
                value="Tous"
                checked={filters.type === "Tous"}
                onChange={(e) => handleChange("type", e.target.value)}
              />
              <label htmlFor="type-tous">Tous</label>
              <input
                type="radio"
                id="type-etage"
                name="type"
                value="Étage"
                checked={filters.type === "Étage"}
                onChange={(e) => handleChange("type", e.target.value)}
              />
              <label htmlFor="type-etage">Étage</label>
            </div>
          </div>

          <div className="filter-group">
            <label>Localisation</label>
            <input
              type="text"
              placeholder="Nice (06000)"
              value={filters.localisation}
              onChange={(e) => handleChange("localisation", e.target.value)}
            />
          </div>

          <div className="filter-group">
            <label>Prix</label>
            <input
              type="range"
              min="0"
              max="1000000"
              step="5000"
              value={filters.prix}
              onChange={(e) => handleChange("prix", Number(e.target.value))}
            />
            <p>{filters.prix.toLocaleString()}€</p>
          </div>

          <div className="filter-footer">
            <button onClick={handleApply} className="apply-button">
              Appliquer
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Filters;
